const CSS = `
.glossy-badge { position: relative; display: inline-flex; align-items: center; justify-content: center; border-radius: 9999px; flex-shrink: 0;
  box-shadow: 0 10px 16px -6px rgba(23, 37, 84, .45), 0 2px 5px -2px rgba(23, 37, 84, .35), inset 0 1.5px 2px rgba(255,255,255,.4), inset 0 -3px 6px rgba(15,23,42,.4); }
.glossy-blue { background: linear-gradient(145deg, #60a5fa 0%, #2563eb 48%, #1e3a8a 100%); }
.glossy-navy { background: linear-gradient(145deg, #3b82f6 0%, #1e40af 45%, #172554 100%); }
.glossy-sky { background: linear-gradient(145deg, #7dd3fc 0%, #0284c7 50%, #0c4a6e 100%); }
.glossy-indigo { background: linear-gradient(145deg, #818cf8 0%, #4f46e5 48%, #312e81 100%); }
.glossy-badge-shine { position: absolute; top: 9%; left: 13%; width: 52%; height: 34%; border-radius: 9999px;
  background: radial-gradient(ellipse at center, rgba(255,255,255,.65) 0%, rgba(255,255,255,0) 72%); filter: blur(.5px); pointer-events: none; }
.glossy-badge { transition: transform .18s ease, box-shadow .18s ease; }
.group:hover .glossy-badge, a:hover .glossy-badge, button:hover .glossy-badge { transform: translateY(-2px) scale(1.06);
  box-shadow: 0 14px 22px -6px rgba(23, 37, 84, .5), 0 3px 6px -2px rgba(23, 37, 84, .35), inset 0 1.5px 2px rgba(255,255,255,.45), inset 0 -3px 6px rgba(15,23,42,.4); }
.group:hover .glossy-badge-shine, a:hover .glossy-badge-shine, button:hover .glossy-badge-shine {
  background: radial-gradient(ellipse at center, rgba(255,255,255,.85) 0%, rgba(255,255,255,0) 72%); }
`;

let styleInjected = false;
function injectCss() {
  if (styleInjected || typeof document === "undefined") return;
  styleInjected = true;
  const el = document.createElement("style");
  el.setAttribute("data-glossy-badge", "");
  el.textContent = CSS;
  document.head.appendChild(el);
}
injectCss();

export function GlossyBadge({ icon: Icon, size = 40, tone = "blue", testid, className = "" }) {
  return (
    <span className={`glossy-badge glossy-${tone} ${className}`} style={{ width: size, height: size }} data-testid={testid} role="presentation">
      <span className="glossy-badge-shine" />
      <Icon style={{ width: size * 0.44, height: size * 0.44 }} className="relative z-10 text-white drop-shadow-sm" />
    </span>
  );
}
